import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed } from "vue"
import { useUtilities } from "@/hooks/useUtilities"
import Icon from "@/components/widgets/icons/Icon.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'Checkbox',
  props: {
  value: {
    type: Boolean,
    required: true,
  },
  label: {
    type: String,
    default: "",
  },
  loading: {
    type: Boolean,
    default: false,
  },
  reversed: {
    type: Boolean,
    default: false,
  },
  primary: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: "24",
  },
},
  emits: ["input", "change"],
  setup(__props, { emit }) {

const props = __props




const checked = ref(false)

const onChange = () => {
  checked.value = !props.value

  emit("input", checked.value)
  emit("change", checked.value)
}

onMounted(() => {
  checked.value = props.value
})

const { generateRand } = useUtilities()

const key = generateRand(3)

const iconKey = computed(() => {
  return checked.value ? generateRand(3) : generateRand(3)
})

return { __sfc: true,props, emit, checked, onChange, generateRand, key, iconKey, Icon }
}

})